/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface NewsletterControllerDownloadImageV1$Params {
  id: string;
  fileName: string;
}

export function newsletterControllerDownloadImageV1(http: HttpClient, rootUrl: string, params: NewsletterControllerDownloadImageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, newsletterControllerDownloadImageV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('fileName', params.fileName, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

newsletterControllerDownloadImageV1.PATH = '/v1/newsletter/{id}/bilder/{fileName}';
